import { createSlice } from '@reduxjs/toolkit'
import { requests } from '../../../core/ajax'

const administrativeLeavesSlice = createSlice({
  name: 'administrativeLeaves',
  initialState: {
    isLoading: false,
    data: [],
    search: {},
    pagination: {},
    selectedRows: [],
  },
  reducers: {
    setLoading: (state, { payload }) => {
      state.isLoading = payload
    },
    setLeavesData: (state, { payload }) => {
      state.data = payload.data
      if (payload.search) {
        state.search = payload.search
      }
      if (payload.pagination) {
        state.pagination = payload.pagination
      }
      state.isLoading = false
    },
    setSelectedLeaves: (state, { payload }) => {
      state.selectedRows = [
        ...state.selectedRows.filter(
          (el) => state.data.map((item) => item.id).indexOf(el.id) === -1
        ),
        ...payload,
      ]
    },
  },
})

export const administrativeLeavesReducer = administrativeLeavesSlice.reducer

export const { setLoading, setLeavesData, setSelectedLeaves } = administrativeLeavesSlice.actions

export const setLeaves = (searchParams, comercializadora_id) => (dispatch) => {
  const { provincia, cod_postal, _search, _num_x_pagina, _pagina, _order_by, _order } = searchParams

  const { get } = requests

  const config = {
    params: {
      provincia,
      cod_postal,
      _search,
      _num_x_pagina,
      _pagina,
      _order_by,
      _order,
    },
    timeout: 0,
  }
  dispatch(setLoading(true))
  get(`bajas_administrativas/`, config)
    .then(({ data }) => {
      dispatch(
        setLeavesData({
          data: data.items,
          search: searchParams,
          pagination: {
            total_paginas: data['total_paginas'],
            total_registros: data['total_registros'],
            pagina_actual: data['pagina_actual'],
          },
        })
      )
    })
    .catch(({ response }) => {
      console.error('Error recuperando clientes con consumo sin contrato', response)
      dispatch(setLoading(false))
    })
}
